export default {
    minLength: {
        value: 200,
        message: 'Wpisz dłuższy opis (min. 200 znaków)',
    },

    maxLength: {
        value: 5000,
        message: 'Skróć opis do 5000 znaków',
    }
}